import { useMsal } from '@azure/msal-react';
import {
    CircularProgress,
    Container,
    Grid,
    Typography,
    Paper,
    IconButton,
    Tooltip,
    Divider,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    TextField
} from '@material-ui/core'
import { FilterList, ArrowForward } from "@material-ui/icons";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { ReactElement, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { useStyles } from './korrelationStyle';
import ZeitFilter from '../../../features/filter/zeit';
import {
    setIsChangedZeit, 
    setEndeCounter, setEndeZeitraum, setStartCounter, setStartDatum, setStartZeitraum, selectStartDatumTemp, setEndeDatum, selectEndeDatumTemp} from '../../../features/filter/zeitSlice';
import MessstellenFilter from '../../../features/filter/messstellen';
import KenngroesseFilter from '../../../features/filter/kenngroesse';
import KorrelationFilter from './korrelationFilter';
import { getKenngroesse, setKenngroesseWert,selectKenngroesseWertTemp, setIsChangedKenngroesse } from '../../../features/filter/kenngroesseSlice';
import { getMessstellen, setMessstelleWert, selectMessstelleWertTemp, setIsChangedMessstelle } from '../../../features/filter/messstellenFilterSlice';
import { selectIsChangedKorrelation, selectKorrelationZwischenTemp, 
    selectKorrelationZwischenWertTemp, selectSliderTemp, 
    setInitFirstLoad, setIsChangedKorrelation, setKorrelationZwischen, setKorrelationZwischenWert, 
    setSlider, getCalculatedKorrelationen, selectselectedCalculatedKorrelation, selectErgebnistyp, } from './korrelationFilterSlice';
import { selectLoadingKorrelation, selectKorrelationList, 
    
    getKorrelation,
    calculateCorrelation} from './korrelationSlice';
import KorrelationTable from './korrelationTable';
import { CorrelationCalculationType, CorrelationResultType } from './korrelationTypes';
import { validateHelper, justNormalValidate } from '../../../features/validate/validate';
import { useParams } from 'react-router';

export default function Korrelation(): ReactElement {

    const { instance } = useMsal();
    const dispatch = useAppDispatch();

    const { id } = useParams<{id: string | undefined}>();

    useEffect(() => {
        dispatch(getCalculatedKorrelationen(id));
        dispatch(getKenngroesse("korrelation"))
        dispatch(getMessstellen());
    }, [instance]);

    const korrelationZwischenTemp = useAppSelector(selectKorrelationZwischenTemp);
    const korrelationZwischenWertTemp = useAppSelector(selectKorrelationZwischenWertTemp);
    const loadingKorrelation = useAppSelector(selectLoadingKorrelation);
    const korrelationResultList = useAppSelector(selectKorrelationList);

    const kenngroesseFilterWert = useAppSelector(selectKenngroesseWertTemp);
    const messstelleFilterWert = useAppSelector(selectMessstelleWertTemp);
    const korrelationSlider = useAppSelector(selectSliderTemp);
    const startDatum =  useAppSelector(selectStartDatumTemp);
    const endeDatum = useAppSelector(selectEndeDatumTemp);

    const isChangedKorrelation = useAppSelector(selectIsChangedKorrelation);

    const selectedCalculatedKorrelation = useAppSelector(selectselectedCalculatedKorrelation);

    const ergebnistyp = useAppSelector(selectErgebnistyp);

    const [selectedTab, setSelectedTab] = React.useState("korrelation");
    const [filter, openFilter] = React.useState(true);

    const [isDialogOpen, setDialogOpen] = React.useState(false);
    const [anfrageName, setAnfrageName] = React.useState('');
    const [dialogError, setDialogError] = React.useState(false);

    const classes = {
        ...globalStyles(),
        ...useStyles()
    };

    return (
        <div>
            <Container maxWidth={false} style={{ marginTop: "10px" }}>
                <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }} >
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <Typography color="primary" variant="h5">
                            Korrelation
                        </Typography>
                    </Grid>
                    <Grid item md={12} >
                    </Grid>
                </Grid>
            </Container>
            <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }} >
                <form className={classes.root} noValidate autoComplete="off" style={{ marginBottom: "10px" }}>
                    <div>
                        <Grid container spacing={4} style={{ marginBottom: "10px" }} >
                            <Grid container item md={12} style={{ paddingLeft: "16px" }}>
                            <Grid container item xs={12} >
                         <Grid item xs={11} ></Grid>
                            {filter ? 
                                <Grid item xs={1} style={{ textAlign: "end" }}>
                                    <IconButton onClick={() => openFilter(false)}>
                                    <Tooltip title="Filter zuklappen">
                                        <ArrowForward />
                                    </Tooltip>
                                    </IconButton> 
                                </Grid> 
                                    : 
                                <Grid item xs={1} style={{ textAlign: "end"}}>
                                    <IconButton onClick={() => openFilter(true)}>
                                    <Tooltip title="Filter aufklappen">
                                    <FilterList />
                                    </Tooltip>
                                </IconButton>
                                </Grid>
                                } 
                                </Grid>
                                <Grid item md={filter ? 7 : 12} >
                                    {loadingKorrelation ? <CircularProgress size="30px" style={{ marginTop: "100px", padding: "1px" }} /> :
                                            korrelationResultList.length > 0 && !isChangedKorrelation
                                                ?   <Grid container item md={12} style={{ paddingTop: "20px" }}>
                                                        <KorrelationTable />
                                                    </Grid>
                                                : <React.Fragment>
                                                    <Grid item md={12} style={{ textAlign: 'left', marginRight: "20px", marginLeft: "50px", paddingTop: "100px" }}>
                                                        <div style={{ height: "30vh" }}>
                                                            <Typography >
                                                                Bitte Filter definieren, um Korrelation anzuzeigen. Bestätigen Sie den Filter über anwenden.
                                                            </Typography>
                                                        </div>
                                                    </Grid>
                                                </React.Fragment>
                                            }
                                </Grid>
                                {filter ?
                                    <React.Fragment>
                                        <Grid item md={5} style={{ paddingLeft: "16px" }}>
                                            <Grid container md={12} style={{ paddingTop: "5px", paddingBottom: "24px", paddingRight: "24px", justifyContent: "end" }}>
                                                <Grid container md={1} style={{margin:"0px", width:"10px", maxWidth:"20px", padding:"0px"}} >
                                                    <Divider orientation="vertical" flexItem />
                                                </Grid>
                                                <Grid item container md={11}>
                                                   
                                                    <Grid item md={12} >   
                                                        <Tabs
                                                            value={selectedTab}
                                                            onChange={(event, value) => setSelectedTab(value)}
                                                            indicatorColor="secondary"
                                                            textColor="secondary"
                                                            TabIndicatorProps={{
                                                                style: {
                                                                    height: "5px",
                                                                }
                                                            }}
                                                        >
                                                            <Tab label="Korrelation" value="korrelation" />
                                                            <Tab label="Zeit" value="zeit" disabled={selectedCalculatedKorrelation?.id > 0} classes={{ disabled: classes.disabledTab }}/>
                                                            <Tab label={"Messstelle ("+ messstelleFilterWert.length +")"} value="messstelle" disabled={(korrelationZwischenTemp==CorrelationCalculationType.betweenKenngroessen && korrelationZwischenWertTemp.value != "Alle") || selectedCalculatedKorrelation?.id > 0} classes={{ disabled: classes.disabledTab }}/>
                                                            <Tab label={"Kenngröße ("+ kenngroesseFilterWert.length +")"} value="kenngroesse" disabled={(korrelationZwischenTemp==CorrelationCalculationType.betweenMessstellen && korrelationZwischenWertTemp.value != "Alle") || selectedCalculatedKorrelation?.id > 0} classes={{ disabled: classes.disabledTab }}/>
                                                        </Tabs>
                                                        {selectedTab == "korrelation" ? <KorrelationFilter /> : ""}
                                                        {selectedTab == "zeit" ? <ZeitFilter typ={"korrelation"} /> : ""}
                                                        {selectedTab == "messstelle" ? <MessstellenFilter name={"korrelation"}/> : ""}
                                                        {selectedTab == "kenngroesse" ? <KenngroesseFilter name={"korrelation"} /> : ""}
                                                        <Grid container md={12} style={{ marginTop: "30px" }} >
                                                            <Grid item container md={6} />
                                                            <Grid item container md={6} style={{ justifyContent: "end" }}>
                                                                {/* <Button
                                                                    style={{ width: "45%" }}
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        dispatch(resetKenngroesseWert());
                                                                        dispatch(resetMessstelleWert());
                                                                        dispatch(resetEndeCounter());
                                                                        dispatch(resetStartCounter());
                                                                        dispatch(resetEndeZeitraum());
                                                                        dispatch(resetStartZeitraum());
                                                                        dispatch(resetStartDatum());
                                                                        dispatch(resetEndeDatum());
                                                                        dispatch(resetKorrelationZwischen());
                                                                        dispatch(resetKorrelationZwischenWert());
                                                                        dispatch(resetSlider());
                                                                        dispatch(setIsChangedMessstelle(false));
                                                                        dispatch(setIsChangedKenngroesse(false));
                                                                        dispatch(setIsChangedZeit(false));
                                                                        dispatch(setIsChangedKorrelation(false));
                                                                        dispatch(setInitFirstLoad(true));
                                                                    }}
                                                                    color="default"
                                                                    className={classes.showDuoButton}
                                                                    disabled={ (korrelationZwischenWertTemp.value == "") || (messstelleFilterWert.length == 0 && kenngroesseFilterWert.length == 0) || (!isChangedZeit && !isChangedKenngroesse && !isChangedMessstelle && !isChangedKorrelation) }>
                                                                    Rückgängig
                                                                </Button> */}
                                                                <Button
                                                                    style={{ width: "45%" }}
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        if(selectedCalculatedKorrelation?.id > 0) {
                                                                            dispatch(setIsChangedKorrelation(false));
                                                                            dispatch(getKorrelation(selectedCalculatedKorrelation.id, ergebnistyp));
                                                                        } else {
                                                                            setDialogOpen(true);
                                                                        }
                                                                    }}
                                                                    color="secondary"
                                                                    className={classes.showDuoButton}
                                                                    disabled={ (korrelationZwischenWertTemp.value == "" || (endeDatum.getTime() - startDatum.getTime()) < 100*24*3600*1000 ||
                                                                    (korrelationZwischenWertTemp.value == "Alle" ? (messstelleFilterWert.length < 2 || kenngroesseFilterWert.length < 2) : false) ||
                                                                    ((korrelationZwischenTemp == CorrelationCalculationType.betweenMessstellen && korrelationZwischenWertTemp.value != "Alle") ? messstelleFilterWert.length < 2 : false) ||
                                                                    ((korrelationZwischenTemp == CorrelationCalculationType.betweenKenngroessen && korrelationZwischenWertTemp.value != "Alle") ? kenngroesseFilterWert.length < 2 : false))
                                                                    && selectedCalculatedKorrelation?.id == null
                                                                    // ||
                                                                    // (!isChangedZeit 
                                                                    // && !isChangedKenngroesse 
                                                                    // && !isChangedMessstelle 
                                                                    // && !isChangedKorrelation) 
                                                                    }>
                                                                    { selectedCalculatedKorrelation?.id > 0 ? "Anzeigen" : "Berechnen" }
                                                                </Button>
                                                                <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
                                                                    <DialogTitle>Name der neu zu berechnenden Korrelation</DialogTitle>
                                                                    <DialogContent>
                                                                        <DialogContentText>
                                                                            Bitte geben Sie einen Namen für die neu zu berechnende Korrelation ein.
                                                                        </DialogContentText>
                                                                        <FormControl className={classes.fullWidth}>
                                                                            <TextField
                                                                                required={true}
                                                                                id="korrelation_anfrage_name"
                                                                                error={dialogError && justNormalValidate(anfrageName)}
                                                                                helperText={validateHelper(anfrageName)}
                                                                                label="Name"
                                                                                variant="outlined"
                                                                                onChange={(event) => setAnfrageName(event.target.value)}
                                                                                value={anfrageName}
                                                                            />
                                                                        </FormControl>
                                                                    </DialogContent>
                                                                    <DialogActions>
                                                                        <Button
                                                                            color="secondary"
                                                                            variant="contained"
                                                                            onClick={() => setDialogOpen(false)}
                                                                            className={classes.cancleDeleteButton}
                                                                        >
                                                                            Abbrechen
                                                                        </Button>
                                                                        <Button
                                                                            variant="contained"
                                                                            onClick={() => {
                                                                                if (!justNormalValidate(anfrageName)) {
                                                                                    setDialogError(false);
                                                                                    dispatch(setKenngroesseWert());
                                                                                    dispatch(setMessstelleWert());
                                                                                    dispatch(setEndeZeitraum());
                                                                                    dispatch(setEndeCounter());
                                                                                    dispatch(setStartZeitraum());
                                                                                    dispatch(setStartCounter());
                                                                                    dispatch(setStartDatum());
                                                                                    dispatch(setEndeDatum());
                                                                                    dispatch(setKorrelationZwischen());
                                                                                    dispatch(setKorrelationZwischenWert());
                                                                                    dispatch(setSlider());
                                                                                    dispatch(setIsChangedMessstelle(false));
                                                                                    dispatch(setIsChangedKenngroesse(false));
                                                                                    dispatch(setIsChangedZeit(false));
                                                                                    dispatch(setIsChangedKorrelation(false));
                                                                                    dispatch(setInitFirstLoad(false));
                                                                                    dispatch(calculateCorrelation(anfrageName, startDatum, endeDatum,
                                                                                    korrelationZwischenTemp, korrelationZwischenWertTemp.value == "Alle" ? CorrelationResultType.count : CorrelationResultType.single,
                                                                                    korrelationZwischenTemp == CorrelationCalculationType.betweenKenngroessen && korrelationZwischenWertTemp.value != "Alle" ? [ korrelationZwischenWertTemp.id ] : messstelleFilterWert.map(x => x.name),
                                                                                    korrelationZwischenTemp == CorrelationCalculationType.betweenMessstellen && korrelationZwischenWertTemp.value != "Alle" ? [ korrelationZwischenWertTemp.id ] : kenngroesseFilterWert.map(x => x.feldname),
                                                                                    korrelationSlider[0], korrelationSlider[1]));
                                                                                    setDialogOpen(false);
                                                                                    setAnfrageName("");
                                                                                } else {
                                                                                    setDialogError(true);
                                                                                }
                                                                            }}
                                                                            color={"secondary"}
                                                                            style={{ minWidth: "120px", minHeight: "36px" }}
                                                                        >
                                                                            {loadingKorrelation ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Abschicken"}
                                                                        </Button>
                                                                    </DialogActions>
                                                                </Dialog>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                    : ""}
                            </Grid>
                        </Grid>
                    </div>
                </form>
            </Paper>
        </div >
    );
}